module.exports = __webpack_public_path__ + "img/utc.174257aa.png";